// src/components/PlanLimitsPanel.js
import React, { useState } from "react";

/**
 * @file PlanLimitsPanel.js
 * @description Component for viewing and editing tenant resource quotas (execution limits, storage).
 */
export default function PlanLimitsPanel({ tenant }) {
  const currentPlan = "Starter";

  const [limits, setLimits] = useState({
    executionQuota: 2000,
    storageQuota: 100,
  });

  const handleSave = () => {
    alert("Resource quotas updated successfully.");
  };

  return (
    <div>
      <div className="row">
        <div className="col-md-6">
          <div className="mb-4">
            <label className="form-label fw-semibold">Current Plan</label>
            <input
              type="text"
              className="form-control bg-light text-capitalize fw-bold"
              value={currentPlan}
              disabled
              readOnly
            />
            <div className="form-text">Estrel SaaS currently supports the Starter plan only.</div>
          </div>
        </div>
      </div>

      <div className="chart-card p-3 mb-4 border rounded bg-white">
        <h6 className="fw-semibold mb-3">Resource Quotas</h6>
        <div className="row g-3">
          <div className="col-md-6">
            <label className="form-label small">Monthly Execution Limit</label>
            <input
              type="number"
              className="form-control"
              value={limits.executionQuota}
              onChange={(e) => setLimits({ ...limits, executionQuota: e.target.value })}
            />
          </div>
          <div className="col-md-6">
            <label className="form-label small">Storage Limit (GB)</label>
            <input
              type="number"
              className="form-control"
              value={limits.storageQuota}
              onChange={(e) => setLimits({ ...limits, storageQuota: e.target.value })}
            />
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-end">
        <button className="btn btn-primary" onClick={handleSave}>
          Save Changes
        </button>
      </div>
    </div>
  );
}